import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { showToast } from "components/ui/toast";

// Get individual orders (admin), server-side paginated.
// params: { page, limit, status, userId, purchaseType }
// response: { success, data, pagination: { page, limit, total, totalPages } }
export const useGetOrdersAdmin = (params = {}, options = {}) =>
  useQuery({
    queryKey: ["orders", "admin", params],
    queryFn: async () => {
      const res = await api.get("/admin/order", { params });
      return res.data;
    },
    staleTime: 2 * 60 * 1000,
    keepPreviousData: true,
    ...options,
  });

// Process an admin-initiated refund (full or partial), with optional reason
export const useProcessRefund = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ orderId, refundAmount, refundReason }) => {
      const res = await api.post(`/admin/order/processRefund/${orderId}`, {
        refundAmount,
        refundReason,
      });
      return res.data;
    },
    onSuccess: () => {
      showToast("success", "Refund processed successfully");
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || "Failed to process refund",
      );
    },
  });
};